"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.feApiReducers = void 0;

var _reduxOidc = require("redux-oidc");

var _isShell = require("./utils/is-shell");
/**
 * A map of reducers from this library to be combined into the rootReducer
 */


var reducers = {};

if (_isShell.isNotInShell) {
  reducers.oidc = _reduxOidc.reducer;
}

var feApiReducers = reducers;
exports.feApiReducers = feApiReducers;